import { API } from 'shared/utils/apiMiddleware';
import { BILLINGS_API_NAME, ACCOUNTS_MANAGEMENT_ROOT } from './helperFunctions';

const dataAccessRoute = `${ACCOUNTS_MANAGEMENT_ROOT}/data-access`;


export async function fetchDataAccessPayerAccounts(isAllAccounts) {
  return API.get(
    BILLINGS_API_NAME,
    `${dataAccessRoute}/payer-accounts${isAllAccounts ? '?isAllAccounts' : ''}`,
  );
}
export const fetchBillingAccounts = async () => API.get('billings', dataAccessRoute);
export const fetchLinkedAccounts = async (id) => API.get('billings', `${dataAccessRoute}/${id}/linked-accounts`);
